@if (heroConfig()) {
  <fin-destination-hero
    [title]="heroConfig().title"
    [backgroundImage]="heroConfig().backgroundImage"
    [destinationCode]="heroConfig().destinationCode"
    [enableAward]="heroConfig().enableAward"
    [enableAurinkomatkat]="heroConfig().enableAurinkomatkat"
    [enablePromoCode]="heroConfig().enablePromoCode"
    [contentType]="heroConfig().contentType"
    [isInCampaign]="heroConfig().isInCampaign"
    [campaignLabel]="campaignLabelKey() | finLocalization: campaignLabelParams()"
    [campaignEndText]="heroConfig().campaignEndText"
    [enableBlackTeaser]="heroConfig().campaignBlackTeaser"
  />
}
